export default "__VITE_ASSET__D3veU1oa__"